/* global rp$, window, $ajax */
'use strict';

const get = require('lodash/get');
const localStorageSlim = require('localstorage-slim');
const cacheConfig = require('public/js/lib/cache-config');
const { applySelectedDealerToDom, clearFindDealerTrigger, updateFindDealerTrigger } = require('public/js/lib/dealer-display');
const { applyPmaMsrpVisibility } = require('public/js/lib/supplier-pricing-display');
const { getDealerModalPostLocationErrorMessage } = require('public/js/lib/dealer-modal-post-location-error-message');
const dust = require('public/js/lib/dust');
const {
	getDealerListCacheId,
} = require('public/js/lib/dealer-selection-modal-helpers');
const { isEnterKeyUpEvent } = require('public/js/lib/keyboard-helpers');
const { LOCATION_CHANGED_EVENT } = require('public/js/lib/location-events');
const {
	persistManualLocationAfterUpdate,
	postLocationUpdate,
} = require('public/js/lib/location-modal-update');
const LOCATION_SOURCE = require('public/js/lib/location-source');
const { SUPPLIER_CHANGED_EVENT } = require('public/js/lib/supplier-events');
const { reconcileSelectedSupplier } = require('public/js/lib/supplier-state');
const { formatHeaderDisplayPostal } = require('public/templates/modules/location/location-helpers');

const googleMapsUtils = require('public/js/helpers/google-maps');
const utils = require('public/js/helpers/utils');
const { getItem, setItem, removeItem, STORAGE_KEYS } = require('public/js/lib/local-storage');

const HEADER_LOCATION_MODULE = '.location-module:not(.pdp-zip-location-modal-host)';

const DealerInfotTempl = require('public/templates/modules/dealer_selection_modal/dealer_info_template.dust');

import './dealer_selection_modal.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const { resetPurchaseModalStyles } = require('public/js/lib/sticky-div');
	const { validatePostalCode } = require('public/js/lib/postal-code-helper');

	// let dealers = [];

	/********************************************
	 * Load Javascript for Dealer Selection Modal Module
	 * -----------------------------------------
	 * @section dealer_selection_modal_js
	 ********************************************/
	(function DealerSelectionModalModule() {
		const CACHE_KEY = STORAGE_KEYS.SUPPLIER_V1;
		const DEALER_LIST_CACHE_KEY = 'dealer_list_v1';
		const DEALER_MODAL_TRIGGER_NAMESPACE = '.dealerSelectionModalTrigger';
		const FIND_DEALER_BUTTON_SELECTOR = '.find-dealer-button';
		const FIND_DEALER_KEYBOARD_TRIGGER_SELECTOR = '.find-dealer-button:not(button)';

		function invalidateSupplierCache() {
			removeItem(CACHE_KEY);
			removeItem(DEALER_LIST_CACHE_KEY);
			dealersFetched = false;
			selectedSupplierFetchInFlight = null;
			lastResolvedHasSelectedSupplier = null;
		}

		// Expose function immediately when module loads
		window.rp_app = window.rp_app || {};
		window.rp_app.invalidateSupplierCache = invalidateSupplierCache;

		let $enterZipButton,
			$enterZipMapButton,
			$dealerSelectionModal,
			$dealerSelectionError,
			$formErrors,
			$selectedDealerContainer,
			$dealerSelectionContainer,
			$dealersListContainer,
			$dealersListInner,
			$zipInput,
			$modalContainer,
			$modalBody,
			$changeDealerWarning,
			$dealerConfirmSection,
			$dealerSelectionSection,
			$dealerConfirmationFooter,
			$dealerConfirmCancel,
			$dealerConfirmSubmit,
			$cartContentList,
			$cartLoadingContainer,
			$brandSelection;


		let map;
		let markers = [];
		const TARGETING_CONSENT_CATEGORY = 'targeting';
		const GOOGLE_MAPS_LOAD_MAX_ATTEMPTS = 40;
		const GOOGLE_MAPS_LOAD_RETRY_MS = 250;
		/** @type {{ data: { modal_map_enabled?: boolean, json?: unknown[] } } | null} */
		let pendingDealerMapRender = null;
		let dealerMapConsentListenerRegistered = false;
		let googleMapsLoadWaitInFlight = false;
		const infoWindows = [];
		const dealers_with_label = [];
		let dealersFetched = false;
		/** After a brand dropdown change we clear skuStripped; show-more must match that request shape. */
		let closestDealerRequestOmitsSkuStripped = false;
		/** True when the postal input was prefilled from cache; auto-submits send empty postal to avoid
		 *  promoting it to the user tier. `#zipInput` is the legacy element id for the postal field. */
		let postalInputIsPrefilled = false;
		let isEffectivePmaSort = false;
		/**
		 * PMA manual-select: when no fulfillment supplier is selected, the modal shows
		 * postal-code entry only (no supplier list/map). Submitting postal code lets the
		 * server resolve and commit the PMA supplier. Once a supplier exists, the standard
		 * change-supplier modal applies. Applied via the `postal-code-only` CSS class.
		 */
		let postalCodeModalState = false;
		/** True once open-time PMA layout sync has finished and the modal may be shown. */
		let dealerModalOpenLayoutSynced = false;
		let selectedSupplierFetchInFlight = null;
		/** @type {boolean|null} */
		let lastResolvedHasSelectedSupplier = null;

		/**
	     * True when PMA manual-select routing applies. `data-is-pma-sort` is set server-side from
         * data.php when sorting is PMA and auto-select is off — the FE does not re-derive it.
		 */
		function usesEffectivePmaRouting() {
			return isEffectivePmaSort;
		}

		function syncHasSelectedSupplierDataAttribute(supplier) {
			if (!$dealerSelectionModal) {
				return;
			}
			const hasSelected = Boolean(supplier?.hash && supplier?.name);
			$dealerSelectionModal.data('has-selected-supplier', hasSelected ? 1 : 0);
		}

		function hasSelectedSupplierLocally() {
			const cached = getItem(CACHE_KEY);
			if (cached && typeof cached === 'object' && cached.hash && cached.name) {
				return true;
			}
			return false;
		}

		function fetchSelectedSupplierFromServer() {
			if (selectedSupplierFetchInFlight) {
				return selectedSupplierFetchInFlight;
			}

			selectedSupplierFetchInFlight = new Promise((resolve) => {
				$ajax({
					method: 'GET',
					url: '/ajax/dealers/selected',
					dataType: 'json',
					success: (response) => {
						const supplier = response?.selected_dealer;
						if (supplier?.name && supplier?.hash) {
							cacheSelectedSupplier(supplier);
							updateSelectedSupplierUI(supplier);
							syncHasSelectedSupplierDataAttribute(supplier);
							lastResolvedHasSelectedSupplier = true;
							// Re-sync PMA MSRP visibility to the confirmed supplier state so a stale
							// localStorage cache can't leave MSRP suppressed with no price shown.
							applyPmaMsrpVisibility();
							resolve(true);
							return;
						}
						removeItem(CACHE_KEY);
						clearFindDealerTrigger();
						syncHasSelectedSupplierDataAttribute(null);
						lastResolvedHasSelectedSupplier = false;
						applyPmaMsrpVisibility();
						resolve(false);
					},
					error: () => {
						if (hasSelectedSupplierLocally()) {
							lastResolvedHasSelectedSupplier = true;
							resolve(true);
							return;
						}
						lastResolvedHasSelectedSupplier = false;
						resolve(false);
					},
				});
			}).then((hasSelectedSupplier) => {
				selectedSupplierFetchInFlight = null;
				return hasSelectedSupplier;
			});

			return selectedSupplierFetchInFlight;
		}

		/**
		 * @param {{ requireServerConfirmation?: boolean }} [options]
		 * @returns {Promise<boolean>}
		 */
		function resolveHasSelectedSupplier(options = {}) {
			const requireServerConfirmation = options.requireServerConfirmation === true;

			if (requireServerConfirmation) {
				selectedSupplierFetchInFlight = null;
				lastResolvedHasSelectedSupplier = null;
				return fetchSelectedSupplierFromServer();
			}

			if (lastResolvedHasSelectedSupplier !== null) {
				return Promise.resolve(lastResolvedHasSelectedSupplier);
			}

			if (hasSelectedSupplierLocally()) {
				return Promise.resolve(true);
			}

			return fetchSelectedSupplierFromServer();
		}

		function resolvePostalCodeModalState(hasSelectedSupplier) {
			return usesEffectivePmaRouting() && !hasSelectedSupplier;
		}

		function applyPostalCodeModalLayout() {
			const $postalSubmit = rp$('#enterZipButton', $dealerSelectionModal);
			if (postalCodeModalState) {
				$dealerSelectionModal.addClass('postal-code-only');
				$modalContainer.removeClass('modal-container-with-map');
				$postalSubmit.addClass('enter-zip-button').removeClass('enter-zip-map-button');
				return;
			}

			$dealerSelectionModal.removeClass('postal-code-only');
			const hasDealerMap = $modalContainer.attr('has-dealer-map') === '1';
			if (hasDealerMap) {
				$postalSubmit.addClass('enter-zip-map-button').removeClass('enter-zip-button');
			} else {
				$postalSubmit.addClass('enter-zip-button').removeClass('enter-zip-map-button');
			}
		}

		function syncPostalCodeModalBeforeOpen() {
			if (!usesEffectivePmaRouting()) {
				postalCodeModalState = false;
				applyPostalCodeModalLayout();
				return Promise.resolve(false);
			}

			return resolveHasSelectedSupplier().then((hasSelectedSupplier) => {
				postalCodeModalState = resolvePostalCodeModalState(hasSelectedSupplier);
				applyPostalCodeModalLayout();
				if (!postalCodeModalState) {
					dealersFetched = false;
				}
				return postalCodeModalState;
			});
		}

		/**
		 * Updates the UI with the selected supplier information.
		 * @param {{ name?: string, hash?: string, interactiveGarageDealerCode?: string }} supplier
		 */
		function updateSelectedSupplierUI(supplier) {
			if (!supplier?.name) {
				return;
			}

			updateFindDealerTrigger(supplier);

			const $contactSupplierDropdown = rp$('.contact-form-module .dealer-dropdown');
			if ($contactSupplierDropdown.length > 0 && supplier.hash) {
				const $selectedSupplierOption = rp$(`.dropdown-item[data-value="${supplier.hash}"]`, $contactSupplierDropdown);
				if ($selectedSupplierOption.length > 0) {
					$selectedSupplierOption.addClass('active');
					const supplierDisplayName = $selectedSupplierOption.attr('data-display') || supplier.name;
					const $labelValue = rp$('.label-value', $contactSupplierDropdown);
					if ($labelValue.length > 0) {
						$labelValue.text(supplierDisplayName);
					}
				}
			}
		}

		/**
		 * Hands the supplier to the shared reconciler so this module and the geo-IP flow write the
		 * same cache entry, and every other surface hears about a genuine change exactly once.
		 * @param {{ name?: string, hash?: string }} supplier
		 */
		function cacheSelectedSupplier(supplier) {
			reconcileSelectedSupplier(supplier);
			if (supplier && supplier.hash && supplier.name) {
				syncHasSelectedSupplierDataAttribute(supplier);
			}
		}

		/**
		 * Geo-IP runs on every non-iframed load and its response now carries the committed supplier,
		 * which reaches this module as `supplier:changed`. Iframed plugin pages never call it (the
		 * parent frame does), so they still have to ask the server themselves.
		 * @returns {boolean}
		 */
		function geoIpResolvesSupplierOnThisPage() {
			const isIframedPage = get(window.rp_app, 'data.plugin_iframe_page') || false;

			return !isIframedPage;
		}

		/**
		 * Loads the selected supplier from cache or the shared page-load fetch.
		 * @returns {Promise<boolean>}
		 */
		function loadSelectedSupplierOnPageLoad() {
			const supplierRedirect = utils.getCookie('supplier_redirect');
			const supplierRefresh = utils.getCookie('supplier_refresh');

			if (/^[a-f0-9]+$/i.test(supplierRedirect) || /^[a-f0-9]+$/i.test(supplierRefresh)) {
				invalidateSupplierCache();
			}
			if (/^[a-f0-9]+$/i.test(supplierRedirect)) {
				utils.deleteCookie('supplier_redirect');
			}
			if (/^[a-f0-9]+$/i.test(supplierRefresh)) {
				utils.deleteCookie('supplier_refresh');
			}

			const cached = getItem(CACHE_KEY);
			if (cached && typeof cached === 'object' && cached.hash && cached.name) {
				updateSelectedSupplierUI(cached);
				syncHasSelectedSupplierDataAttribute(cached);
				lastResolvedHasSelectedSupplier = true;
				return Promise.resolve(true);
			}
			if (cached) {
				removeItem(CACHE_KEY);
			}

			// Fetching here would only duplicate the answer geo-IP is already bringing back, and the
			// two responses would race over the same cache key. Resolve as "not known yet" rather
			// than "no supplier" so modal-open still confirms with the server if no event arrives.
			return geoIpResolvesSupplierOnThisPage()
				? Promise.resolve(false)
				: fetchSelectedSupplierFromServer();
		}

		function clearError() {
			$formErrors.html('');
		}

		// -- Zip Submission Container --
		function zipSubmissionWorking() {
			$enterZipButton.addClass('disabled');
			$enterZipMapButton.addClass('disabled');
			$dealerSelectionContainer.addClass('show loading');
		}

		function zipSubmissionReady() {
			$enterZipButton.removeClass('disabled');
			$enterZipMapButton.removeClass('disabled');
			$dealerSelectionContainer.removeClass('loading');
		}



		function processingMapMarkers(dealers){
			markers.forEach(m => m.marker.setMap(null));
			markers.length = 0;
			dealers_with_label.length = 0;
			infoWindows.length = 0;

			let counter = 1;
			var color = '#007bff';
			dealers.forEach(dealer => {
				dealers_with_label.push({label:counter, dealer:dealer});
				counter++;
			});
			dealers_with_label.forEach(d => {
				var label = d.label;
				var dealer = d.dealer;
				var marker, address, fullAddress, geocoder , pos;
				address = dealer.dealerAddress;
				fullAddress = `${address.address1}, ${address.city}, ${address.state}, ${address.postalCode}, ${address.country}`;

				if (dealer.latitude !== 0 && dealer.longitude !== 0) {
					pos = new google.maps.LatLng(dealer.latitude, dealer.longitude);
					if(label === 1){
						map.center = pos;
					}

					var labelConverted = googleMapsUtils.numberToLetter(label);
					var svgIcon = googleMapsUtils.generateIcon(labelConverted, color);

					const customMarkerIcon = {
						url: svgIcon,
						scaledSize: new google.maps.Size(32, 32),
						anchor: new google.maps.Point(16, 32),
					};

					const markerDiv = document.createElement('div');
					markerDiv.innerHTML = svgIcon;
					markerDiv.style.position = 'relative';
					markerDiv.style.width = '48px';
					markerDiv.style	.height = '48px'; 

					marker = new google.maps.Marker({
						position: pos,
						content: markerDiv,
						icon: customMarkerIcon,
					});

					var result = utils.getXItemsFromString(dealer.dealerBrands, ',', 2);
					const brands_st = `${result.selected.join(', ')} and more`;

					var contentString = '';

					dust.render(DealerInfotTempl, {icon:svgIcon, dealer:dealer, address:fullAddress, brands:brands_st}, (err, output) => {
						if (err) {
							console.error(err);
						} else {
							contentString = output;
						}
					});

					const infoWindow = new google.maps.InfoWindow({
						content: contentString,
						headerDisabled: true,
						ariaLabel: dealer.dealerName,
					});

					marker.addListener('click', () => {
						closeAllInfoWindows();
						infoWindow.open({
							anchor: marker,
							map,
							shouldFocus: false
						});

						$('.dealer-row').removeClass('highlighted');

						let dataHashSelector = '[data-hash="'+dealer.dealerHash+'"]';
						$(dataHashSelector).closest('.dealer-row').addClass('highlighted');

						onMarkerClick(dataHashSelector);

						infoWindows.push(infoWindow);
					});
					marker.setMap(map);
					markers.push({position:label, distance: dealer.distance,marker:marker});

					google.maps.event.addListener(map, 'click', () => {
						closeAllInfoWindows();
					});
				} else {
					console.log('Warehouse did not have lat/lon coordinates');
				}
			});
		}

		function closeAllInfoWindows(){
			for (let i = 0; i < infoWindows.length; i++) {
				infoWindows[i].close();
			}
		}
		function onMarkerClick(dataHashSelector) {
			const $dealer = $(dataHashSelector);
			$dealer[0].scrollIntoView({ behavior: 'smooth', block: 'end' });
		}

		function handleZipSubmissionSuccess(data) {
			if (data) {
				clearError();
				zipSubmissionReady();
				$zipInput.val(data.postal_code_value);
				postalInputIsPrefilled = false;
				$brandSelection.val(data.brand_selection_value);
				$selectedDealerContainer.html(data.selected_dealer_html);
				if ($dealersListInner && $dealersListInner.length) {
					$dealersListInner.html(data.dealer_list_html);
				}
			}
		}

		function handleZipSubmissionError(errorMessage) {
			$formErrors.html(`${errorMessage}`);
			zipSubmissionReady();
		}

		function handlePostalCodeModalSupplierResolutionFailure() {
			const message = $modalBody.data('error-location-saved-supplier-failed')
				|| $modalBody.data('error-generic');
			handleZipSubmissionError(message);
		}


		/**
		 * GET /ajax/dealers-by-distance. Server resolves location from cookies/session only
		 * (see DealerController::findDealersByClosestSorting). `postalCode` is omitted from the GET
		 * query but still feeds `getDealerListCacheId` (with visible-zip fallback) for client cache busting.
		 */
		function fetchDealers(payload) {
			return new Promise((resolve, reject) => {
				// Fall back to the visible zip so a tier change busts the cache instead of serving
				// stale dealers keyed by the prefilled auto-submit's empty postal.
				const cacheKeyPostalCode = payload.postalCode || $zipInput.val() || '';
				const cacheId = getDealerListCacheId({ ...payload, postalCode: cacheKeyPostalCode });
				const cached = getItem(DEALER_LIST_CACHE_KEY);
				if (cached && cached.id === cacheId && cached.data) {
					resolve(cached.data);
					return;
				}

				const requestQuery = Object.assign({}, payload);
				delete requestQuery.postalCode;

				window.rp_app.request({
					method: 'GET',
					url: '/ajax/dealers-by-distance',
					dataType: 'json',
					data: requestQuery,
					success: (data = {}) => {
						setItem(DEALER_LIST_CACHE_KEY, { id: cacheId, data }, {
							ttl: window.rp_app.cacheConfig.getTtlFor('supplier')
						});
						resolve(data);
					},
					error: (jqXHR) => {
						if (jqXHR.status === 400) {
							reject('400 error');
						} else {
							reject('ajax error');
						}
					}
				});
			});
		}

		const INITIAL_DEALER_COUNT = 3;

		function updateShowMoreDealersButton(showLoadMore, responseData) {
			const root = $dealersListContainer[0];
			if (!root) {
				return;
			}
			const btn = root.querySelector('.show-all-dealers-btn');
			if (!(btn instanceof HTMLButtonElement)) {
				return;
			}
			const shouldShow = Boolean(
				showLoadMore && responseData && responseData.json && responseData.json.length >= INITIAL_DEALER_COUNT,
			);
			if (shouldShow) {
				btn.classList.remove('hidden');
				btn.removeAttribute('disabled');
				btn.setAttribute('aria-hidden', 'false');
			} else {
				btn.classList.add('hidden');
				btn.setAttribute('disabled', '');
				btn.setAttribute('aria-hidden', 'true');
			}
		}

		function buildClosestDealerRequestPayload(isAutomaticSubmission, numberOfSuppliers) {
			let skuStripped = null;
			let catalog = null;
			const selectedBrand = ($brandSelection.val() || "").toLowerCase();
			const $productModule = rp$('.product-purchase-module');
			const $productPageModule = $productModule.length > 0 ? $productModule : rp$('.product-offer-module');

			if ($productPageModule.length > 0) {
				const catalogData = ($productPageModule.attr('data-catalog') || '').toLowerCase();
				if (selectedBrand === catalogData || selectedBrand === '' || selectedBrand === 'allbrands') {
					skuStripped = $productPageModule.attr('data-sku-stripped') || null;
				}
				catalog = selectedBrand === "allbrands" ? "" : selectedBrand || catalogData;
			} else {
				catalog = selectedBrand === "allbrands" ? "" : selectedBrand;
			}

			// Auto-submits with a prefilled zip send empty so the server keeps its resolved tier
			// instead of promoting the cached value to the user tier.
			const postalCode = (isAutomaticSubmission && postalInputIsPrefilled) ? '' : ($zipInput.val() || '');

			const payload = {
				postalCode,
				html: true,
				skuStripped,
				catalog,
				skipSupplierSelectionReporting: isAutomaticSubmission
			};

			if (numberOfSuppliers) {
				payload.numberOfSuppliers = numberOfSuppliers;
			}

			return payload;
		}

		function reloadPageAfterDealerModalMutation() {
			invalidateSupplierCache();
			$dealerSelectionModal.modal('hide');
			window.location.reload();
		}

		function getCurrentlyAllowedConsentCategories() {
			const getAllowed = globalThis.rp_app?.consent?.getCurrentlyAllowedConsentCategories;
			return typeof getAllowed === 'function' ? getAllowed() : [];
		}

		function isTargetingConsentAllowed(allowedCategories) {
			return allowedCategories.includes(TARGETING_CONSENT_CATEGORY);
		}

		function isGoogleMapsApiReady() {
			return Boolean(globalThis.google?.maps);
		}

		function isDealerMapBlockedByConsent() {
			const subscribe = globalThis.rp_app?.consent?.onAllowedConsentCategoriesChange;
			if (typeof subscribe !== 'function') {
				return false;
			}

			return !isTargetingConsentAllowed(getCurrentlyAllowedConsentCategories());
		}

		function waitForGoogleMapsApi(attemptsRemaining, callback) {
			if (isGoogleMapsApiReady()) {
				callback();
				return;
			}

			if (attemptsRemaining <= 0) {
				return;
			}

			globalThis.setTimeout(() => {
				waitForGoogleMapsApi(attemptsRemaining - 1, callback);
			}, GOOGLE_MAPS_LOAD_RETRY_MS);
		}

		function applyDealerMapFromResponse(data) {
			if (!map) {
				initMap(dealerCenter(data.json));
			}
			processingMapMarkers(data.json);
			processMapMarkerSideBar();
		}

		function tryRenderPendingDealerMap() {
			if (!pendingDealerMapRender) {
				return;
			}

			const { data } = pendingDealerMapRender;
			if (!data?.modal_map_enabled) {
				pendingDealerMapRender = null;
				return;
			}

			if (isDealerMapBlockedByConsent()) {
				ensureDealerMapConsentListener();
				return;
			}

			if (isGoogleMapsApiReady()) {
				applyDealerMapFromResponse(data);
				pendingDealerMapRender = null;
				googleMapsLoadWaitInFlight = false;
				return;
			}

			if (googleMapsLoadWaitInFlight) {
				return;
			}

			googleMapsLoadWaitInFlight = true;
			waitForGoogleMapsApi(GOOGLE_MAPS_LOAD_MAX_ATTEMPTS, () => {
				googleMapsLoadWaitInFlight = false;
				tryRenderPendingDealerMap();
			});
		}

		function retryDealerMapWhenConsentAllows(allowedCategories) {
			if (!isTargetingConsentAllowed(allowedCategories)) {
				return;
			}

			tryRenderPendingDealerMap();
		}

		function ensureDealerMapConsentListener() {
			const subscribe = globalThis.rp_app?.consent?.onAllowedConsentCategoriesChange;
			if (typeof subscribe !== 'function' || dealerMapConsentListenerRegistered) {
				return;
			}

			dealerMapConsentListenerRegistered = true;
			subscribe(retryDealerMapWhenConsentAllows);
		}

		function queueDealerMapRender(data) {
			if (!data?.modal_map_enabled) {
				return;
			}

			pendingDealerMapRender = { data };
			ensureDealerMapConsentListener();
			tryRenderPendingDealerMap();
		}

		function renderDealerResponse(data, showLoadMore, isUserDriven) {
			zipSubmissionReady();
			handleZipSubmissionSuccess(data.html);
			queueDealerMapRender(data);

			updateShowMoreDealersButton(showLoadMore, data);

			if (isUserDriven) {
				syncHeaderLocationFromDealerResponse(data);
			}
		}

		// Mirrors the header location modal: when the dealer modal accepts a user-typed ZIP, the server
		// queues a user-tier cookie. Update the header DOM + cache so they don't drift until next nav.
		function syncHeaderLocationFromDealerResponse(data) {
			const location = data?.location;
			if (!location) {
				return;
			}

			const displayPostal = String(location.postal_code || location.postalCode || '').trim();
			if (displayPostal === '') {
				return;
			}

			rp$(`${HEADER_LOCATION_MODULE} .location-value`)
				.html(formatHeaderDisplayPostal(displayPostal, location));
			persistManualLocationAfterUpdate(displayPostal, location);
		}

		// Manual zip flow: POST /ajax/update-location to promote the user-tier cookie, persist
		// the cache entry, broadcast LOCATION_CHANGED_EVENT, then refetch dealers from the
		// now-current cookie. Keeps location-write responsibility on a single endpoint and lets
		// header / PDP repaint via the shared event.
		function persistAndBroadcastManualLocation(data) {
			const location = data?.location;
			if (!location) {
				return null;
			}
			const displayPostal = String(location.postal_code || location.postalCode || '').trim();
			if (displayPostal === '') {
				return null;
			}
			persistManualLocationAfterUpdate(displayPostal, location);
			rp$(document).trigger(LOCATION_CHANGED_EVENT, [{
				postalCode: displayPostal,
				location,
				source: LOCATION_SOURCE.MANUAL,
			}]);
			return displayPostal;
		}

		function handleShowAllDealers(e) {
			const btn = e?.currentTarget;
			if (!(btn instanceof HTMLButtonElement) || btn.disabled) {
				return;
			}
			const container = $dealersListContainer?.[0];
			if (!container) {
				return;
			}
			btn.disabled = true;
			const previousCount = container.querySelectorAll('.dealer-row').length;
			const payload = buildClosestDealerRequestPayload(true);
			if (closestDealerRequestOmitsSkuStripped) {
				payload.skuStripped = null;
			}
			zipSubmissionWorking();

			fetchDealers(payload)
				.then(data => {
					renderDealerResponse(data, false);
					const rows = container.querySelectorAll('.dealer-row');
					if (rows.length > previousCount) {
						rows[previousCount].scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				})
				.catch((error) => {
					btn.disabled = false;
					if (error === '400 error') {
						handleZipSubmissionError($modalBody.data('error-400'));
					} else {
						handleZipSubmissionError($modalBody.data('error-500'));
					}
				});
		}

		function submitPostalCodeForSupplierSelection(e) {
			e?.preventDefault();

			if (rp$(this).hasClass('disabled')) {
				return;
			}

			const postalCode = ($zipInput.val() || '').trim();
			if (!validatePostalCode(postalCode)) {
				return handleZipSubmissionError($modalBody.data('error-invalid-zip'));
			}

			clearError();
			zipSubmissionWorking();

			postLocationUpdate({ postalCode })
				.then((updateLocationData) => {
					const persistedPostal = persistAndBroadcastManualLocation(updateLocationData);
					if (persistedPostal === null) {
						handleZipSubmissionError($modalBody.data('error-invalid-zip'));
						return;
					}
					const selectedSupplier = updateLocationData?.selected_dealer ?? null;
					const location = updateLocationData?.location;
					if (location) {
						rp$(`${HEADER_LOCATION_MODULE} .location-value`)
							.html(formatHeaderDisplayPostal(persistedPostal, location));
					}
					invalidateSupplierCache();

					if (selectedSupplier?.name) {
						return resolveHasSelectedSupplier({ requireServerConfirmation: true }).then((hasSelectedSupplier) => {
							if (!hasSelectedSupplier) {
								handlePostalCodeModalSupplierResolutionFailure();
								return;
							}
							$dealerSelectionModal.modal('hide');
							window.location.reload();
						});
					}

					return fetchDealers({
						...buildClosestDealerRequestPayload(false, INITIAL_DEALER_COUNT),
						postalCode: '',
					})
						.then(() => {
							// PMA commit is on update-location when auto-select rules allow it.
							// dealers-by-distance only re-runs PMA when no fulfillment is committed yet
							// (avoids double metrics); an empty list is not proof of failure. Always
							// confirm fulfillment before surfacing an error or reloading.
							return resolveHasSelectedSupplier({ requireServerConfirmation: true }).then((hasSelectedSupplier) => {
								if (!hasSelectedSupplier) {
									handlePostalCodeModalSupplierResolutionFailure();
									return;
								}
								$dealerSelectionModal.modal('hide');
								window.location.reload();
							});
						})
						.catch(() => {
							handlePostalCodeModalSupplierResolutionFailure();
						});
				})
				.catch((error) => {
					const message = getDealerModalPostLocationErrorMessage($modalBody, error);
					if (message !== null) {
						handleZipSubmissionError(message);
						return;
					}
					handleZipSubmissionError($modalBody.data('error-generic'));
				});
		}

		function handleZipSubmission(e, isAutomaticSubmission) {
			if (postalCodeModalState) {
				submitPostalCodeForSupplierSelection.call(this, e);
				return;
			}

			e?.preventDefault();

			if (rp$(this).hasClass('disabled')) {
				return;
			}

			const postalCode = $zipInput.val() || '';
			if (e != null && !validatePostalCode(postalCode)) {
				return handleZipSubmissionError($modalBody.data('error-invalid-zip'));
			}

			clearError();

			closestDealerRequestOmitsSkuStripped = false;
			const payload = buildClosestDealerRequestPayload(isAutomaticSubmission, INITIAL_DEALER_COUNT);
			const isUserDriven = Boolean(e) && !isAutomaticSubmission && (payload?.postalCode ?? '') !== '';

			zipSubmissionWorking();

			if (isUserDriven) {
				promoteManualPostalThenFetchDealers(postalCode, payload);
				return;
			}

			fetchDealers(payload)
				.then((data) => renderDealerResponse(data, true, isUserDriven))
				.catch((error) => {
					const message = getDealerModalPostLocationErrorMessage($modalBody, error);
					if (message !== null) {
						handleZipSubmissionError(message);
						return;
					}
					handleFetchDealersError(error);
				});
		}

		function promoteManualPostalThenFetchDealers(postalCode, payload) {
			postLocationUpdate({ postalCode })
				.then((updateLocationData) => {
					const persistedPostal = persistAndBroadcastManualLocation(updateLocationData);
					if (persistedPostal === null) {
						handleZipSubmissionError($modalBody.data('error-invalid-zip'));
						return;
					}
					const selectedSupplier = updateLocationData?.selected_dealer ?? null;
					applySelectedDealerToDom(selectedSupplier);
					syncHasSelectedSupplierDataAttribute(selectedSupplier);
					// Re-sync MSRP visibility to the supplier just reconciled, so suppressed MSRP-only
					// blocks don't linger (blank gap) while the dealer list shows.
					applyPmaMsrpVisibility();
					// Server now has the user-tier cookie; clear postal so the dealer endpoint
					// resolves from cookies (no double-promotion path).
					return fetchDealers({ ...payload, postalCode: '' });
				})
				.then((data) => {
					if (data === undefined) {
						return;
					}
					renderDealerResponse(data, true, true);
				})
				.catch((error) => {
					const message = getDealerModalPostLocationErrorMessage($modalBody, error);
					if (message !== null) {
						handleZipSubmissionError(message);
						return;
					}
					handleFetchDealersError(error);
				});
		}

		function handleFetchDealersError(error) {
			if (error === '400 error') {
				handleZipSubmissionError($modalBody.data('error-400'));
			} else {
				handleZipSubmissionError($modalBody.data('error-500'));
			}
		}

		function handleCatalogChange(e, isAutomaticSubmission) {
			e?.preventDefault();
			closestDealerRequestOmitsSkuStripped = true;
			let catalog = e.target.value.toLowerCase();
			if (catalog === 'allbrands') {
				catalog = '';
			}

			const payload = buildClosestDealerRequestPayload(isAutomaticSubmission, INITIAL_DEALER_COUNT);
			payload.catalog = catalog;
			payload.skuStripped = null;

			zipSubmissionWorking();
			fetchDealers(payload)
				.then(data => renderDealerResponse(data, true))
				.catch(handleFetchDealersError);
		}

		function processMapMarkerSideBar(){
			var color = '#007bff';
			dealers_with_label.forEach(d => {
				var letterLabel = googleMapsUtils.numberToLetter(d.label);
				var markMap = googleMapsUtils.generateIcon(letterLabel, color);
				$('.map-marker-'+d.label).prop('src', markMap);
			});
		}

		function handleClearDealerSuccess() {
			clearError();
			invalidateSupplierCache();
			$dealerSelectionModal.modal('hide');
			window.location.reload();
		}

		function handleClearDealer() {
			window.rp_app.request({
				method: 'GET',
				url: '/ajax/dealers/clear',
				dataType: 'json',
				success: (response, status) => {
					if (status === 'success') {
						handleClearDealerSuccess();
					}
				}
			});
		}

		function dealerSelectionWorking(selectDealerButton) {
			selectDealerButton.addClass('disabled');
			$modalBody.find('.select-dealer-map-button').addClass('disabled');
		}

		function dealerSelectionReady() {
			$modalBody.find('.select-dealer-button').removeClass('disabled');
			$modalBody.find('.select-dealer-map-button').removeClass('disabled');

		}

		function handleCartFetch(e) {
			e?.preventDefault();
			e?.stopPropagation();

			dealerModalOpenLayoutSynced = false;
			resetPurchaseModalStyles(true);
			$modalContainer.removeClass('modal-container-with-map');
			$cartLoadingContainer.addClass('loading');

			$changeDealerWarning.addClass('hidden');
			$dealerConfirmSection.addClass('hidden');
			$dealerSelectionSection.addClass('hidden');
			$dealerConfirmationFooter.addClass('hidden');

			syncPostalCodeModalBeforeOpen().then((isPostalCodeOnly) => {
				dealerModalOpenLayoutSynced = true;
				$dealerSelectionModal.modal('show');

				if (isPostalCodeOnly) {
					$cartLoadingContainer.removeClass('loading');
					$dealerSelectionSection.removeClass('hidden');
					return;
				}

				window.rp_app.request({
					type: 'GET',
					url: '/ajax/cart',
					dataType: 'json',
					contentType: 'application/json',
					success: handleCartHasItems,
					error: handleCartFetchError,
				});
			});
		}

		function handleCartFetchError() {
			// Proceed as empty cart so supplier selection still opens.
			handleCartHasItems({ itemsCount: 0, items: [] });
		}

		function handleCartHasItems(cart) {
			$cartContentList.empty();
			$cartLoadingContainer.removeClass('loading');

			const cartHasItems = !!get(cart, 'itemsCount');
			// PMA postal-only mode has no selected supplier to "change", so the change-dealer cart
			// confirmation does not apply. Route these buyers straight to ZIP entry so they can
			// assign their first PMA supplier even when the cart already has line items.
			if (cartHasItems && !postalCodeModalState) {
				$changeDealerWarning.removeClass('hidden');

				$dealerConfirmSection.removeClass('hidden');
				$dealerConfirmationFooter.removeClass('hidden');
				$dealerSelectionSection.addClass('hidden');

				const $cartItems = get(cart, 'items');
				$cartItems.forEach(function CartItems_Iterator(item) {
					const $row = document.createElement('div');
					const $title = document.createElement('p');
					const $sku = document.createElement('p');

					$row.className = 'cart-content-row';
					$title.className = 'cart-item-title';
					$sku.className = 'cart-item-sku';
					$title.textContent = get(item, 'title');
					$sku.textContent = get(item, 'product_id');

					$row.append($title);
					$row.append($sku);

					$cartContentList.append($row);
				});
				$dealerConfirmSubmit.removeAttr('disabled');

			} else {
				$changeDealerWarning.addClass('hidden');

				$dealerConfirmSection.addClass('hidden');
				$dealerConfirmationFooter.addClass('hidden');
				$dealerSelectionSection.removeClass('hidden');
				if (!postalCodeModalState) {
					const $hasDealerMap = $modalContainer.attr('has-dealer-map') === '1';
					if ($hasDealerMap) {
						$modalContainer.addClass('modal-container-with-map');
					}
				}
			}

			if (!postalCodeModalState && !dealersFetched) {
				dealersFetched = true;
				handleZipSubmission.call(document.createElement('div'), null, true);
			}
		}

		function handleDealerSelectionSuccess() {
			clearError();
			dealerSelectionReady();
			reloadPageAfterDealerModalMutation();
		}

		function handleDealerSelectionError(errorMessage) {
			$dealerSelectionError.html(`${errorMessage}`);
			dealerSelectionReady();
		}

		function handleDealerSelection(e) {
			e.preventDefault();

			if (rp$(this).hasClass('disabled')) {
				return;
			}

			const dealerHash = rp$(e.target).data('hash');
			if (!dealerHash) {
				return handleDealerSelectionError($modalBody.data('error-400'));
			}

			clearError();

			// Perform Submission
			dealerSelectionWorking(rp$(this));
			window.rp_app.request({
				method: 'POST',
				url: '/ajax/dealers',
				dataType: 'json',
				data: { dealerHash },
				success: handleDealerSelectionSuccess,
				statusCode: {
					400: () => {
						dealerSelectionReady();
						handleDealerSelectionError($modalBody.data('error-400'));
					}
				},
				error: () => {
					dealerSelectionReady();
					handleDealerSelectionError($modalBody.data('error-500'));
				}
			});
		}

		function handleDealerConfirmSubmit(e) {
			e.preventDefault();

			$dealerConfirmSection.addClass('hidden');
			$dealerConfirmationFooter.addClass('hidden');
			$dealerSelectionSection.removeClass('hidden');
			if (!postalCodeModalState) {
				const $hasDealerMap = $modalContainer.attr('has-dealer-map') === '1';
				if ($hasDealerMap) {
					$modalContainer.addClass('modal-container-with-map');
				}
			}
		}

		function dealerCenter(dealers) {
			const list = Array.isArray(dealers) ? dealers : [];
			const dealer = list.find((item) => item.latitude !== 0 && item.longitude !== 0);
			return dealer
				? { lat: dealer.latitude, lng: dealer.longitude }
				: { lat: 0, lng: 0 };
		}

		function initMap(center) {
			map = new google.maps.Map(document.getElementById('map_dealers'), {
				center,
				zoom: 5,
			});
		}
		$onReady({
			rp$, window, document,
			label: 'dealer_selection_modal',
			fn: function () {
				// $mapsSelector = rp$("#map_dealers");
				$dealerSelectionModal = rp$('.dealer-selection-modal');
				isEffectivePmaSort = $dealerSelectionModal.data('is-pma-sort') === 1;
				postalCodeModalState = usesEffectivePmaRouting() && !hasSelectedSupplierLocally();
				// Bootstrap data-toggle opens the modal before async PMA layout sync can run.
				rp$(FIND_DEALER_BUTTON_SELECTOR).removeAttr('data-toggle');
				$modalBody = rp$('.modal-body', $dealerSelectionModal);
				$modalContainer = rp$('.modal-container');
				$enterZipButton = rp$('.enter-zip-button', $dealerSelectionModal);
				$enterZipMapButton = rp$('.enter-zip-map-button', $dealerSelectionModal);
				$dealerSelectionError = rp$('.dealer-selection-errors', $dealerSelectionModal);
				$formErrors = rp$('.form-errors', $dealerSelectionModal);
				$selectedDealerContainer = rp$('.selected-dealer-container', $dealerSelectionModal);
				$dealerSelectionContainer = rp$('.dealer-selection-container', $dealerSelectionModal);
				$dealersListContainer = rp$('.dealers-list-container', $dealerSelectionModal);
				$dealersListInner = rp$('#dealersListInner', $dealerSelectionModal);
				$zipInput = rp$('.zip-input', $dealerSelectionModal);
				$changeDealerWarning = rp$('.change-dealer-warning', $dealerSelectionModal);
				$dealerSelectionSection = rp$('.dealer-selection', $dealerSelectionModal);
				$dealerConfirmationFooter = rp$('.dealer-confirmation-footer', $dealerSelectionModal);
				$dealerConfirmSection = rp$('.dealer-confirm', $dealerSelectionModal);
				$dealerConfirmCancel = rp$('.change-dealer-cancel', $dealerSelectionModal);
				$dealerConfirmSubmit = rp$('.change-dealer-confirm', $dealerSelectionModal);
				$cartLoadingContainer = rp$('.cart-loading-container', $dealerSelectionModal);
				$cartContentList = rp$('.cart-content-list', $dealerSelectionModal);
				$brandSelection = rp$('.brand-selection');

				const $modal = rp$('#dealerSelectionWarningModal');
				if ($modal && typeof $modal.on === 'function') {
					$modal.on('hidden.bs.modal', () => resetPurchaseModalStyles(false));
				}

				rp$(document)
					.off(`click${DEALER_MODAL_TRIGGER_NAMESPACE}`, FIND_DEALER_BUTTON_SELECTOR)
					.on(`click${DEALER_MODAL_TRIGGER_NAMESPACE}`, FIND_DEALER_BUTTON_SELECTOR, handleCartFetch)
					.off(`keyup${DEALER_MODAL_TRIGGER_NAMESPACE}`, FIND_DEALER_KEYBOARD_TRIGGER_SELECTOR)
					.on(`keyup${DEALER_MODAL_TRIGGER_NAMESPACE}`, FIND_DEALER_KEYBOARD_TRIGGER_SELECTOR, function handleEnterKeyUp(e) {
						if (!isEnterKeyUpEvent(e)) {
							return;
						}

						e.preventDefault();
						rp$(this).trigger('click');
					});

				// Sync zip input to the shared location cache on every open so header-zip changes
				// are reflected when the modal reopens.
				$dealerSelectionModal.on('show.bs.modal', function handleDealerModalShow(e) {
					if (usesEffectivePmaRouting() && !dealerModalOpenLayoutSynced) {
						e.preventDefault();
						return;
					}

					let cached = null;
					try {
						cached = localStorageSlim.get(cacheConfig.LOCATION_CACHE_KEY);
					} catch (_err) {
						cached = null;
					}
					const cachedPostal = cached?.postalCode || '';
					if (cachedPostal === '' || $zipInput.val() === cachedPostal) {
						return;
					}
					$zipInput.val(cachedPostal);
					if (postalCodeModalState) {
						return;
					}
					postalInputIsPrefilled = true;
					// Dealer list was fetched for the old location; force the auto-submit path to
					// refetch against the new one instead of leaving stale rows in the modal.
					dealersFetched = false;
				});

				// If the buyer's location changes (browser-geolocation grant, Geo-IP refresh, or a
				// manual zip from another module) while this modal is already open, repaint the
				// zip input and refetch dealers. Closed-modal case is handled by the
				// `show.bs.modal` reconciler above (which reads LOCATION_CACHE_KEY).
				const dealerModalLocationChangedNamespace = '.dealerSelectionModalLocationSync';
				rp$(document).off(LOCATION_CHANGED_EVENT + dealerModalLocationChangedNamespace);
				rp$(document).on(LOCATION_CHANGED_EVENT + dealerModalLocationChangedNamespace, function handleLocationChangedForDealerModal(_event, payload) {
					if (!$dealerSelectionModal.hasClass('show')) {
						return;
					}
					const newPostal = String(payload?.postalCode ?? '').trim();
					if (newPostal === '') {
						return;
					}
					if (postalCodeModalState) {
						$zipInput.val(newPostal);
						return;
					}
					const currentVal = $zipInput.val();
					const inputIsOursToOverwrite = postalInputIsPrefilled || currentVal === '';
					if (!inputIsOursToOverwrite || currentVal === newPostal) {
						return;
					}
					$zipInput.val(newPostal);
					postalInputIsPrefilled = true;
					dealersFetched = false;

					closestDealerRequestOmitsSkuStripped = false;
					const refetchPayload = buildClosestDealerRequestPayload(true, INITIAL_DEALER_COUNT);
					zipSubmissionWorking();
					fetchDealers(refetchPayload)
						.then((data) => renderDealerResponse(data, true, false))
						.catch(handleFetchDealersError);
				});

				// Added the modal click event to the submit button itself.
				$enterZipButton.on('click', handleZipSubmission);
				$enterZipMapButton.on('click', handleZipSubmission);
				$zipInput.on('input', function clearPrefilledFlag() {
					postalInputIsPrefilled = false;
				});
				$zipInput.on('keyup', function handleZipEnterKeyed(e) {
					e.preventDefault();

					if (isEnterKeyUpEvent(e)) {
						handleZipSubmission(e);
					}

					return false;
				});


				$selectedDealerContainer .on('click', '.clear-dealer-link', handleClearDealer);

				$modalBody.on('click', '.select-dealer-button', handleDealerSelection);
				$modalBody.on('click', '.select-dealer-map-button', handleDealerSelection);
				$dealerConfirmSubmit.on('click', handleDealerConfirmSubmit);
				$brandSelection.on('change', handleCatalogChange);
				$modalBody.on('click', '.show-all-dealers-btn', handleShowAllDealers);

				// Repaints from whichever flow resolved the supplier, so this module no longer depends
				// on winning a fetch race with geo-IP to show the dealer name.
				rp$(document).on(SUPPLIER_CHANGED_EVENT, function handleSupplierChanged(_event, payload) {
					const supplier = payload?.supplier;
					if (!supplier?.name) {
						return;
					}

					updateSelectedSupplierUI(supplier);
					syncHasSelectedSupplierDataAttribute(supplier);
					lastResolvedHasSelectedSupplier = true;
					rp$('.selected-dealer-container', $dealerSelectionModal).removeClass('hidden');
					rp$('.change-dealer-warning', $dealerSelectionModal).removeClass('hidden');

					if (usesEffectivePmaRouting()) {
						postalCodeModalState = resolvePostalCodeModalState(true);
						applyPostalCodeModalLayout();
					}
					applyPmaMsrpVisibility();
				});

				loadSelectedSupplierOnPageLoad().then((hasSelectedSupplier) => {
					if (hasSelectedSupplier) {
						rp$('.selected-dealer-container', $dealerSelectionModal).removeClass('hidden');
						rp$('.change-dealer-warning', $dealerSelectionModal).removeClass('hidden');
					}
					if (usesEffectivePmaRouting()) {
						postalCodeModalState = resolvePostalCodeModalState(hasSelectedSupplier);
						applyPostalCodeModalLayout();
					}
					applyPmaMsrpVisibility();
				});
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
